@if (storesLoading) {
  <div class="as-fixed-loader">
    <ng-lottie width="150px" height="150px" [options]="options"> </ng-lottie>
    <mat-label class="as-roboto-slab as-font-bold as-font-20 as-font-red">
      {{ loadingText }}...
    </mat-label>
  </div>
}
<mat-progress-bar
  mode="determinate"
  value="40"
  color="accent"
></mat-progress-bar>
<div class="as-dialog-main-container">
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer as-mb-1em"
      mat-dialog-close
    ></mat-icon>
  </div>
  @if (!displayAvailableStores) {
    <mat-label class="as-roboto-slab as-font-18 as-font-bold">
      {{ selectedOption ? "" : ("DELIVERY.selectOption" | translate) }}
    </mat-label>
    @if (!selectedOption) {
      <br />
    }
    @if (!selectedOption) {
      <br />
    }
    @if (selectedOption === 'pickup') {
      <p
        class="as-font-16 selected-option as-font-bold"
        >
        {{ "ADDRESSES.enterNameOrStoreAddress" | translate }} <br /><br />
      </p>
    }
    <div class="as-delivery-container">
      @if (!isPickup) {
        <div class="as-row as-justify-sb">
          <div
            matRipple
            class="as-delivery-option"
            [class.selected]="selectedOption === 'delivery'"
            (click)="onSelectingOption('delivery')"
            >
            <img class="as-img-option" src="assets/images/delivery.png" />
            <mat-label
              class="as-font-14"
              innerHtml="{{ 'DELIVERY.homeDelivery' | translate }}"
            ></mat-label>
          </div>
          <div
            matRipple
            class="as-delivery-option"
            [class.selected]="selectedOption === 'pickup'"
            (click)="onSelectingOption('pickup')"
            >
            <img class="as-img-option" src="assets/images/pickup.png" />
            <mat-label
              class="as-font-14"
              innerHtml="{{ 'DELIVERY.storePickup' | translate }}"
            ></mat-label>
          </div>
        </div>
      }
      @if (selectedOption === 'pickup') {
        @if (selectedOption) {
          <div>
            <mat-form-field appearance="outline" color="accent">
              <mat-label>{{
                "ADDRESSES.nameOrStoreAddress" | translate
              }}</mat-label>
              <input
                mask="00000"
                [formControl]="zipCodeForm"
                matInput
                type="text"
                />
            </mat-form-field>
          </div>
        }
      }
      <div class="as-column as-align-center">
        <button
          mat-flat-button
          color="accent"
          class="as-dialog-action-button"
          (click)="continue()"
          [disabled]="
            selectedOption === 'delivery' ? false : zipCodeForm.invalid
          "
          >
          <mat-label class="as-font-14 as-font-semibold as-font-white">
            {{ "GENERAL.continue" | translate }}
          </mat-label>
        </button>
      </div>
    </div>
  } @else {
    <div class="as-available-stores-container">
      <br />
      <div class="container">
        <div class="cont">
          <p class="as-font as-font-16">
            <strong>{{ "DELIVERY.branches" | translate }}</strong>
          </p>
          <mat-label class="as-font as-font-16">
            {{ referenceAddress.zipcode ? "Código Postal" : "Dirección" }}
            {{
            referenceAddress.zipcode
            ? referenceAddress.zipcode
            : referenceAddress.detail
            }}
          </mat-label>
        </div>
        <p
          (click)="changeAddress()"
          class="as-font as-font-16 as-font-green as-pointer as-font-semibold"
          >
          {{ "DELIVERY.change" | translate }}
        </p>
      </div>
      @if (!storesLoading && nearStores.length > 0) {
        <mat-label
          class="as-roboto-slab as-font-18 as-font-bold"
          >
          {{ "DELIVERY.selectStore" | translate }}
        </mat-label>
      }
      <mat-dialog-content
        ><br />
        @if (storesLoading) {
          <div
            class="as-row as-justify-center as-spinner-green"
            >
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
        @if (!storesLoading && nearStores.length > 0) {
          <div>
            @for (store of nearStores; track store) {
              <div
                class="as-store-tile"
                [class.as-selected]="store.name === tempAddressStore?.displayName"
                matRipple
                (click)="setDefaultAddress(store)"
                >
                <div class="as-column">
                  <mat-label class="as-font-semibold as-font-14">
                    {{ store.name }}
                  </mat-label>
                  <mat-label class="as-font-14"> {{ store.address }} </mat-label>
                </div>
                <div class="as-row as-align-center">
                  <mat-icon svgIcon="ic-pin-red"></mat-icon>
                  <mat-label class="as-font-14">
                    {{
                    store.meters >= 1000
                    ? (store.meters / 1000 | number : "1.2-2")
                    : store.meters
                    }}
                    {{ store.meters >= 1000 ? "km" : "m" }}
                  </mat-label>
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="no-stores as-font-bold as-font as as-font-18">
            {{ "STORES.noStores" | translate }}
          </p>
        }
        <ng-template #noStores>
          <p class="no-stores as-font-bold as-font as as-font-18">
            {{ "STORES.noStores" | translate }}
          </p>
        </ng-template>
        <br />
      </mat-dialog-content>
      <mat-dialog-actions class="as-row as-justify-end as-align-center">
        <mat-label
          class="as-font-bold as-font-green as-font-underline as-pointer"
          (click)="goBack()"
          >
          {{ "GENERAL.back" | translate }}
        </mat-label>
        <button
          [disabled]="!tempAddressStore"
          mat-flat-button
          color="accent"
          class="as-continue-button"
          (click)="onSettingAddress()"
          >
          <mat-label class="as-font-14 as-font-semibold as-font-white">
            {{ "GENERAL.continue" | translate }}
          </mat-label>
        </button>
      </mat-dialog-actions>
    </div>
  }
</div>
